import React from 'react'

interface EventCardProps {}

export const EventCard: React.FC<React.PropsWithChildren<EventCardProps>> = ({
  children
}) => {
  return (
    <div
      className={`ease-in transition-all py-6 px-5 border-[1px] border-solid border-[#91caff] rounded-lg bg-[#e6f4ff]`}
    >
      {children}
    </div>
  )
}
